import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Button } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { ModelBase } from "@models";
import { 
  Race, 
  Character,
  CharacterRace,
} from "@dndModels";

import API from "@utilities/smart_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import CharacterFeatureSourcesOuter from "@dndComponents/character/features/CharacterFeatureSourcesOuter";
import SelectObjectIndex from "@dndComponents/select/SelectObjectIndex";
import CharacterCreatureTypeCustomization from '../customizations/CharacterCreatureTypeCustomization';

interface Props {
  char: Character;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterRaceInput({
  char,
}: Props) {
  const [change_race, setChangeRace] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [filter, setFilter] = useState<any>({});
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    console.log("Char Race - Recalculated");
    setTimeout(() => {
      // if (processing) {
      setProcessing(false);
      // }
      // if (change_race) {
      setChangeRace(false);
      // }
    }, 100);
  }, [processing, change_race]);

  // const subscribed = useRef(false);

  useEffect(() => {
    // if (subscribed.current) return;
    // subscribed.current = true;
    char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  }, [char, recalculated]);

  const updateFilter = (changed: any) => {
    const new_filter = {...changed};
    
    const search_string = api.search_string;
    if (search_string !== "") {
      new_filter.search_string = search_string;
    }
    const source_book = api.get_filter("source_book");
    if (Object.keys(source_book).length > 0) {
      new_filter.source_book_ids = source_book;
    }

    setFilter(new_filter);
  }

  console.log("Race disappearing sometimes. Aasimar, Uriel. Changeling, Mask");
  console.log(data_util.races.filter(o => o.name.includes("Aasimar") || o.name.includes("Changeling")));
  const char_race = char.spirit.race;
  if (!char_race || char_race.source_id === "" || change_race) {
    return (
      <Grid container spacing={0} direction="row">
        { char_race && char_race.source && change_race && 
          <Grid size={12}>
            { char_race.source.true_name } 
            <Button 
              fullWidth variant="contained" color="primary" 
              onClick={ () => {
                setChangeRace(false);
              }}>
                Keep { char.c_options.races_called }
            </Button>
          </Grid>
        }
        { processing ?
          <Grid size={12} className="header centered">Setting { char.c_options.races_called }</Grid>
        :
          <Grid size={12}>
            <SelectObjectIndex
              data_type="race"
              character={char}
              blocked_ids={char.c_options.blocked}
              quick_fields={["creature_size","creature_type"]}
              filter={filter}
              updateFilter={updateFilter}
              // log_it
              onClick={ async (race2: ModelBase) => {
                // debugger;
                if (race2 instanceof Race) {
                  setProcessing(true);
                  await api.loadObject(race2);
                  char_util.removeCharFeatureBasesFor(char, char.spirit.race);
                  char.spirit.race.char_feature_bases = [];
                  const changed = new CharacterRace();
                  await changed.copy_source({ char: char, feature_source: race2 });
                  char.spirit.race = changed;

                  char.spirit.race.table = await data_util.getTableAsync(race2); 
                  if (char.base_size < 1 && race2.sizes.length > 0 && !race2.sizes.includes(7)) {
                    char.spirit.base_size = race2.sizes[0]; 
                  }
                  char.changed();
                  
                  // // debugger;
                  // setTimeout(() => {
                  char.subscription_holder.recalculate();
                  // }, 100);
                }
              }}
              disableObj={(obj: ModelBase) => {
                let disabled = false;
                let reasons = "";
                if (obj instanceof Race && char.spirit.race.source_id === obj._id) {
                  disabled = true;
                  reasons = "You already have this " + char.c_options.races_called;
                }
                return { disabled, reasons };
              }}
            />
          </Grid>
        }
      </Grid>
    );
  } else if (char_race.source) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={6}
          className="header">
          { char_race.source && <span>{ char_race.source.true_name }</span> }
        </Grid>
        <Grid size={6}>
          <Button 
            fullWidth variant="contained" color="primary" 
            onClick={ () => {
              setChangeRace(true);
            }}>
              Change { char.c_options.races_called }
          </Button>
        </Grid>
        <Grid size={12}>
          <CharacterFeatureSourcesOuter
            char={char}
            sources={[char_race]}
            change_time={0}
            expanded_cfs_id={char_race.true_id}
            onCFSSelect={() => { }}
            extra_cfs_header_control={() => {
              return (
                <CharacterCreatureTypeCustomization char={char} />
              );
            }}
          />
        </Grid>
      </Grid>
    );
  } else return null;
}
